export function onIdle(fn: () => void, timeoutMs = 2000): void {
  if (typeof requestIdleCallback === "function") requestIdleCallback(() => fn(), { timeout: timeoutMs });
  else setTimeout(fn, timeoutMs);
}
